export enum PaymentMethod {
  CASH = 'CASH',
  //OXXOPAY = 'OXXOPAY', // Deprecated, do not use (kept for retro compatibility)
  OTHER = 'OTHER',
}
